import styled from 'styled-components';

// Style
import { colors, fontSize } from '../../styles/variables';

/**
 * Formata o Container do Resumo
 * @extends {div} Tag div nativa do HTML
 *
 * Herda estilo para formatar o interior do Container
 * @extends {fontSize}
 * @extends {colors}
 */
export const StyleSummary = styled.div`
  width: 100%;
  height: fit-content;
  padding: 1rem;
  background-color: ${colors.grey.light};
  margin-bottom: 1rem;

  h2 {
    color: ${colors.primary};
    font-size: ${fontSize.lg};
    text-align: center;
    margin-bottom: 1rem;
  }

  ul {
    list-style: none;
    border-bottom: 2px solid ${colors.primary};

    li {
      padding: 0.8rem 0.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: ${fontSize.sm};
      color: ${colors.primary};

      span {
        line-height: 1.4;

        &:first-of-type {
          font-weight: bold;
        }

        &:last-of-type {
          max-width: 160px;
        }
      }

      &:nth-child(odd) {
        background-color: ${colors.grey.lightPrimary};
      }
    }
  }
`;

/**
 * Formata o bloco de Total do Resumo
 * @extends {div} Tag div nativa do HTML
 *
 * Herda estilo para formatar o interior do bloco
 * @extends {fontSize}
 * @extends {colors}
 */
export const StylePrice = styled.div`
  font-size: ${fontSize.md};
  color: ${colors.primary};
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 0.5rem;

  & > span {
    font-size: ${fontSize.sm};

    &:first-of-type {
      text-transform: uppercase;
      font-weight: 900;

      span {
        font-weight: 400;
        font-size: ${fontSize.md};
        margin-left: 1rem;
      }
    }

    &:last-of-type {
      font-weight: 900;
      color: ${colors.secondary};
    }
  }
`;

/**
 * Formata o bloco destacado de Prazos Estimados
 * @extends {div} Tag div nativa do HTML
 *
 * Herda estilo para formatar o interior do bloco
 * @extends {fontSize}
 * @extends {colors}
 */
export const StyleDeadlineBox = styled.div`
  background-color: #fef9e7;
  border: 1px solid #f0d861;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;

  .deadline-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;

    .deadline-icon {
      font-size: 1.4rem;
    }

    strong {
      font-size: ${fontSize.md};
      color: ${colors.primary};
    }
  }

  .deadline-details {
    list-style: none;
    padding: 0;
    margin: 0 0 0.75rem 0;

    li {
      justify-content: flex-start;
      font-size: ${fontSize.sm};
      color: ${colors.primary};
      padding: 0.25rem 0 0.25rem 1.9rem;
      line-height: 1.5;
    }

    strong{
      margin-right: 0.3rem;
    }
  }

  .deadline-note {
    font-size: ${fontSize.sm};
    color: ${colors.primary};
    font-style: italic;
    padding-left: 1.9rem;

    strong {
      font-style: normal;
    }
  }
`;